const wordList = [
  // Entry Level: Short Words (3 characters)
  "bat",
  "cat",
  "dog",
  "red",
  "box",
  "top",
  "sun",
  "car",
  "bag",
  "pen",
  "cap",
  "fun",
  "hat",
  "log",
  "man",
  "map",
  "pop",
  "run",
  "row",
  "wet",
  "pig",
  "ice",
  "jam",
  "key",
  "lip",
  "mix",
  "new",
  "old",
  "pit",
  "rag",
  "sea",
  "tin",
  "van",
  "yes",
  "zip",
  "arc",
  "bud",
  "cut",
  "dry",
  "egg",
  "fan",
  "gem",
  "hut",
  "ivy",
  "job",
  "kit",
  "low",
  "nap",
  "owl",
  "pan",
  "web",
  "sip",
  "dot",
  "lot",
  "tap",
  "tap",
  "rip",
  "bag",
  "bit",
  "bot",
  "sip",
  "map",
  "cap",
  "jam",
  "dot",
  "vat",
  "git",
  "raw",
  "sad",
  "tag",
  "tip",
  "bun",
  "pet",
  "run",
  "sit",
  "sub",
  "ten",
  "bus",
  "bug",
  "van",
  "pit",
  "pet",
  "bat",
  "top",
  "tab",
  "rot",
  "tar",
  "jar",
  "lit",
  "tip",

  // Medium Words: (4 characters)
  "blue",
  "tree",
  "game",
  "fire",
  "wolf",
  "zoom",
  "jump",
  "rock",
  "star",
  "cold",
  "dark",
  "lamp",
  "rain",
  "ship",
  "time",
  "wave",
  "gift",
  "good",
  "grow",
  "high",
  "land",
  "moon",
  "open",
  "peak",
  "road",
  "safe",
  "slow",
  "wind",
  "wood",
  "year",
  "zone",
  "calm",
  "clap",
  "dust",
  "ever",
  "fear",
  "glow",
  "gold",
  "grip",
  "heat",
  "hill",
  "iron",
  "kind",
  "life",
  "note",
  "path",
  "rise",
  "sing",
  "snow",
  "stop",
  "talk",
  "view",
  "walk",
  "wild",
  "data",
  "code",
  "test",
  "read",
  "study",
  "mark",
  "quiz",
  "home",
  "idea",
  "time",
  "read",
  "work",
  "note",
  "edit",
  "list",
  "file",
  "plan",
  "goal",
  "task",
  "copy",
  "pass",
  "goal",
  "find",
  "task",
  "race",
  "match",
  "link",
  "show",
  "read",
  "pick",
  "work",
  "write",
  "mail",
  "edit",
  "rich",
  "kind",
  "fast",
  "slow",
  "rest",
  "vote",
  "zoom",
  "chat",
  "gift",
  "plan",

  // Long Words: (5 characters)
  "apple",
  "beach",
  "cloud",
  "dance",
  "flame",
  "grass",
  "heart",
  "jelly",
  "light",
  "movie",
  "night",
  "ocean",
  "party",
  "queen",
  "river",
  "shine",
  "smile",
  "space",
  "storm",
  "sugar",
  "table",
  "thing",
  "tiger",
  "torch",
  "trust",
  "voice",
  "world",
  "youth",
  "zebra",
  "angle",
  "armor",
  "brave",
  "chase",
  "clear",
  "creek",
  "dress",
  "faith",
  "glide",
  "grave",
  "hover",
  "knife",
  "level",
  "lucky",
  "peace",
  "plate",
  "polar",
  "scope",
  "sleep",
  "solid",
  "sweet",
  "tower",
  "trace",
  "track",
  "value",
  "water",
  "wheel",
  "study",
  "learn",
  "topic",
  "pupil",
  "class",
  "room",
  "grade",
  "test",
  "task",
  "skill",
  "memo",
  "research",
  "library",
  "study",
  "block",
  "debug",
  "class",
  "index",
  "align",
  "array",
  "loops",
  "bytes",
  "print",
  "compile",
  "logic",
  "value",
  "input",
  "stack",
  "button",
  "coding",
  "class",
  "stage",
  "input",
  "shift",
  "scope",
  "value",

  // Very Long Words: (6 characters)
  "banana",
  "bridge",
  "castle",
  "charge",
  "circle",
  "dragon",
  "flight",
  "flower",
  "forest",
  "future",
  "hunger",
  "island",
  "jungle",
  "market",
  "motion",
  "oyster",
  "planet",
  "prince",
  "prison",
  "rescue",
  "rocket",
  "school",
  "shadow",
  "shield",
  "silver",
  "source",
  "strike",
  "stream",
  "symbol",
  "talent",
  "tunnel",
  "vision",
  "volume",
  "window",
  "winter",
  "absorb",
  "artist",
  "beyond",
  "camera",
  "candle",
  "dinner",
  "dreams",
  "empire",
  "fusion",
  "growth",
  "honest",
  "impact",
  "intent",
  "lovers",
  "master",
  "moment",
  "nation",
  "nature",
  "nobody",
  "parlor",
  "resist",
  "program",
  "error",
  "syntax",
  "output",
  "code",
  "compile",
  "matrix",
  "logic",
  "debug",
  "stack",
  "style",
  "class",
  "button",
  "editor",
  "public",
  "inner",
  "system",
  "inputs",
  "print",
  "scan",
  "index",
  "loop",
  "value",
  "search",
  "update",
  "switch",
  "input",
  "print",
  "target",
  "query",
  "array",
  "align",
  "enter",
  "record",
  "learn",
  "result",
  "study",

  // Advanced Level: Words with 7 characters
  "android",
  "captain",
  "control",
  "crystal",
  "decline",
  "density",
  "diamond",
  "discuss",
  "element",
  "fiction",
  "fortune",
  "general",
  "gravity",
  "history",
  "imagery",
  "journey",
  "justice",
  "kitchen",
  "kingdom",
  "manager",
  "mariner",
  "monster",
  "morning",
  "natural",
  "network",
  "octopus",
  "outlook",
  "passion",
  "pattern",
  "perfect",
  "picture",
  "popular",
  "produce",
  "quality",
  "reactor",
  "release",
  "resolve",
  "science",
  "soldier",
  "species",
  "success",
  "surface",
  "survive",
  "temple",
  "theater",
  "trouble",
  "victory",
  "welcome",
  "program",
  "python",
  "android",
  "binary",
  "debug",
  "device",
  "closure",
  "output",
  "indexer",
  "stack",
  "model",
  "parser",
  "forloop",
  "swift",
  "gitflow",
  "render",
  "buffer",
  "query",
  "input",
  "compile",
  "structure",
  "class",
  "matrix",
  "integer",
  "version",
  "update",
  "icon",
  "format",
  "input",
  "network",
  "create",
  "runtime",
  "request",
  "handler",
  "encrypt",
  "format",
  "server",
  "debugger",
  "visual",
  "remote",
  "update",
  "tracking",
  "reboot",

  // Grandmaster Level: Complex to type
  "velocity",
  "aerodrome",
  "geometry",
  "computer",
  "keyboard",
  "function",
  "terminal",
  "parallel",
  "compiler",
  "sequence",
  "variable",
  "developer",
  "packages",
  "dynamics",
  "resource",
  "equation",
  "software",
  "optimize",
  "abstract",
  "learning",
  "flexible",
  "argument",
  "balanced",
  "external",
  "hardware",
  "progress",
  "training",
  "research",
  "platform",
  "settings",
  "designer",
  "advanced",
  "strategy",
  "pipeline",
  "feedback",
  "analyze",
  "debugger",
  "security",
  "database",
  "framework",
  "solution",
  "browser",
  "reliable",
  "analytics",
  "frontend",
  "backend",
  "document",
  "function",
  "hypervelocity",
  "aerodynamics",
  "gravitational",
  "astrophysics",
  "interstellar",
  "extraterrestrial",
  "microgravity",
  "quasarsandquarks",
  "quantization",
  "ionization",
  "thermodynamics",
  "spectroscopy",
  "parallelism",
  "ultraviolet",
  "supercluster",
  "eventhorizon",
  "cosmological",
  "darkmatter",
  "neutronstar",
  "eigenvectors",
  "cryptography",
  "infrastructure",
  "characteristic",
  "congratulations",
  "differentiation",
  "generalization",
  "localization",
  "decomposition",
  "synchronization",
  "hyperparameter",
  "revolutionary",
  "superconductivity",
  "information",
  "initialization",
  "procrastination",
  "suboptimization",
  "digitalization",
  "misconfiguration",
  "decentralization",
  "computational",
  "superimposition",
  "microcontrollers",
];

export default wordList;
